var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.modifiedTable)?_c('QuickAccessTable',{attrs:{"item":_vm.item,"table":_vm.modifiedTable}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }